<template>
  <div>
    <div class="flex flex-wrap mt-8">
      <div
        class="w-full sm:w-1/2 mb-2 p-2"
        v-for="service in services"
        v-bind:key="service._id"
      >
        <ServiceCard
          :id="service.id"
          :title="service.title"
          :description="service.description"
          :address="service.address"
          :supplier_rating="service.supplier_rating"
          :min_price="service.min_price"
          :max_price="service.max_price"
          :imageUrl="service.image_url"
        />
      </div>
    </div>
    <div class="w-full text-center mt-2">
      <Pagination />
    </div>
  </div>
</template>
<script>
import api from "../api";

import ServiceCard from "../components/ServiceCard.vue";
import Pagination from "../components/Pagination.vue";

export default {
  name: "ServiceList",
  components: {
    ServiceCard,
    Pagination
  },
  props: {
    category: String
  },
  watch: {
    category: {
      immediate: true, 
      handler () {
        this.getServices()
      }
    }
  },
  data() {
    return {
      services: []
    };
  },
  async mounted() {
    let response = await api.get(`/services/${this.category||'all'}`);
    if (!response.ok) {
        this.services = []
      for (let i = 0; i < 6; i++) {
        this.services.push({
          id: "service_id_"+i,
          title: "Título " + (i + 1),
          description: "Descripción " + (i + 1),
          address: "Dirección " + (i + 1),
          supplier_rating: Math.round(Math.random() * 4)+1,
          min_price: Math.round(Math.random() * 20)+80,
          max_price: Math.round(Math.random() * 100)+100,
          image_url:
            "https://image.freepik.com/foto-gratis/bonito-carpintero-nivel-burbuja_1098-15261.jpg"
        });
      }
      return;
    }
    this.services = response.data.services || [];
  },
  methods: {
    async getServices() {
      let response = await api.get(`/services/${this.category||'all'}`);
      if (!response.ok) {
        this.services = []
        for (let i = 0; i < 6; i++) {
          this.services.push({
            id: "service_id_"+i,
            title: "Título " + (i + 1),
            description: "Descripción " + (i + 1),
            address: "Dirección " + (i + 1),
            supplier_rating: Math.round(Math.random() * 4)+1,
            min_price: Math.round(Math.random() * 20)+80,
            max_price: Math.round(Math.random() * 100)+100,
            image_url:
              "https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          });
        }
        return;
      }
      this.services = response.data.services || [];
    }
  }
};
</script>